import React, { Dispatch, SetStateAction } from "react";
import "./index.scss";
import { Typography } from "components/atoms";

interface IProps {
  icsLink: string;
  googleLink: string;
  outLookLink: string;
  yahooLink: string;
  setIsExternalCalenderListShow: Dispatch<SetStateAction<boolean>>;
}

export const AddToExternalCalenderList = ({
  icsLink,
  googleLink,
  outLookLink,
  yahooLink,
  setIsExternalCalenderListShow,
}: IProps) => {
  const handleClick = (link: string) => {
    window.open(link, "__blank");
    setIsExternalCalenderListShow((prev) => !prev);
  };
  return (
    <div className="external-calender-list">
      <div
        className="external-calender-list-item apple first"
        onClick={() => handleClick(icsLink)}
      >
        <Typography variant="h8Book" label="Apple Calendar" />
      </div>
      <div
        className="external-calender-list-item google"
        onClick={() => handleClick(googleLink)}
      >
        <Typography variant="h8Book" label="Google" />
      </div>
      <div
        className="external-calender-list-item outlook"
        onClick={() => handleClick(outLookLink)}
      >
        <Typography variant="h8Book" label="Outlook" />
      </div>
      <div
        className="external-calender-list-item outlook-com"
        onClick={() => handleClick(icsLink)}
      >
        <Typography variant="h8Book" label="Outlook.com" />
      </div>
      <div
        className="external-calender-list-item yahoo last"
        onClick={() => handleClick(yahooLink)}
      >
        <Typography variant="h8Book" label="Yahoo" />
      </div>
    </div>
  );
};
